import { ColumnSortBar, FilterableList } from 'metrix-common3';
import { TRIAGE_COLUMNS, TRIAGE_FIELDS } from './fields';
import PolicyListItem from './Results/PolicyListItem';

const PAGE_SIZE = 25;

// One fixed width for the 8-column table; the FilterableList track scrolls horizontally on narrower
// screens so mobile scrolls to all columns instead of collapsing.
const ITEM_MIN_WIDTH = '1500px';

const Triage = (props) => {
    const { context, reference, products, incompletePolicies, query, showFilters, onActiveFiltersChange } = props;
    const triage = query.triage;

    // Products arrive as { code, name }; the shared component expects { code, value }.
    const productOptions = (products || []).map((product) => ({ code: product.code, value: product.name }));

    // Push the query into Redux (the saga's source of truth) under query.triage, then fetch. Both
    // query + clear read the applied state via doQueryTriagePolicies, so no separate get is needed.
    const applyQuery = (filters, page) => {
        props.doReduceView('triage');
        for (const [code, value] of Object.entries(filters)) {
            props.doReduceQueryElement({ code, value });
        }
        props.doReduceQueryElement({ code: 'skip', value: (page - 1) * PAGE_SIZE });
        props.doReduceQueryElement({ code: 'take', value: PAGE_SIZE });
        props.doQueryTriagePolicies();
    };

    const runQuery = ({ filters, page, hasActiveFilters }) => {
        applyQuery(filters, page);
        onActiveFiltersChange?.(hasActiveFilters);
    };

    // Sorting is owned by the page: set the order, reset to the first page, and re-query.
    const handleSort = (columnName) => {
        props.doReduceView('triage');
        props.doReduceQueryElement({ code: 'orderByFieldNames', value: [columnName] });
        props.doReduceQueryElement({
            code: 'orderByDesc',
            value: triage.orderByFieldNames?.[0] === columnName ? !triage.orderByDesc : true,
        });
        props.doReduceQueryElement({ code: 'skip', value: 0 });
        props.doQueryTriagePolicies();
    };

    return (
        <FilterableList
            fields={TRIAGE_FIELDS}
            roles={[context.session.userType]}
            references={reference.references}
            onLoadReference={(code) => reference.doGetReferences(code)}
            extras={{ products: productOptions }}
            items={incompletePolicies}
            keyOf={(policy) => policy.policyTransactionGuid}
            renderItem={(policy) => <PolicyListItem policy={policy} context={context} />}
            sortBar={
                <ColumnSortBar
                    columns={TRIAGE_COLUMNS}
                    sortBy={triage.orderByFieldNames?.[0]}
                    orderByDesc={triage.orderByDesc}
                    onSort={handleSort}
                />
            }
            itemMinWidth={ITEM_MIN_WIDTH}
            persistKey='policies.triage'
            pageSize={PAGE_SIZE}
            hasNext={incompletePolicies?.length === PAGE_SIZE}
            showFilters={showFilters}
            onQuery={runQuery}
            onClear={runQuery}
        />
    );
};

export default Triage;
